"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as m } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 11.65a2.65 2.65 0 0 0 2.65 2.65 2.66 2.66 0 0 0 2.65-2.65 2.65 2.65 0 0 0-5.3 0m1.251.007a1.41 1.41 0 0 1 1.4-1.416c.779 0 1.413.63 1.418 1.41a1.409 1.409 0 0 1-2.818.006m6.099-.007A2.65 2.65 0 0 0 12 14.3a2.66 2.66 0 0 0 2.65-2.65 2.65 2.65 0 0 0-5.3 0m1.251.007A1.41 1.41 0 0 1 12 10.24c.78 0 1.413.63 1.419 1.41a1.409 1.409 0 0 1-2.818.006M19.35 14.3A2.65 2.65 0 1 1 22 11.65a2.66 2.66 0 0 1-2.65 2.65m0-4.059a1.409 1.409 0 1 0 1.418 1.41 1.42 1.42 0 0 0-1.418-1.41",
        clipRule: "evenodd"
      }
    )
  }
), n = m(l);
export {
  n as More,
  n as default
};
